import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

function Formi(props) {
  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [username, setusername] = useState("");
  const [site, setsite] = useState("-");
  const [subnotes, setnotes] = useState("-");
  const [suffix, setsuffix] = useState("-");

  const [due, setdue] = useState("First");
  const [consumption_option, setcon] = useState("LIMITED");
  const [connectivity, setcona] = useState("");
  const [expiration_date, setda] = useState("");
  let [plans, setplans] = useState([]);
  const [client, setclient] = useState("");
  const [plani, setplano] = useState("");
  let [notes, setcil] = useState([]);

  const [sites, setSites] = useState([]); // New state for sites
  const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]); // New state for wireless access points
  const [cores, setCores] = useState([]); // New state for cores
  const [selectedSite, setSelectedSite] = useState(""); // New state for selected site
  const [selectedWirelessAccessPoint, setSelectedWirelessAccessPoint] =
    useState(""); // New state for selected wireless access point
  const [selectedCore, setSelectedCore] = useState(""); // New state for selected core
  console.log(selectedCore);

  const [cpeMacAddress, setCpeMacAddress] = useState(""); // New state
  const [cpeError, setCpeError] = useState(""); // New state

  const [selectedSiteLabel, setSelectedSiteLabel] = useState("");

  const specialSites = ["AYSAR", "EZONE", "SAEED"];

  const validate = () => {
    // Basic validations (remove 'site' if it is not intended, or update it accordingly)
    if (!username || !connectivity || !client || !plani) {
      return false;
    }

    // Wireless-specific validation
    if (connectivity === "Wireless") {
      // for special sites we don’t require an actual MAC
      if (specialSites.includes(selectedSiteLabel)) {
        return Boolean(selectedWirelessAccessPoint);
      }

      // otherwise require a real, valid MAC
      if (
        !selectedSite ||
        !selectedWirelessAccessPoint ||
        !isValidMacAddress(cpeMacAddress)
      ) {
        return false;
      }
      return true;
    }

    // Fiber-specific validation
    if (connectivity === "Fiber") {
      if (!selectedCore) {
        return false;
      }
      return true; // Return true if the Fiber-specific field is valid
    }

    return false; // Default to false for any other unexpected cases
  }; // New Validate function

  useEffect(() => {
    let isMounted = true;

    const getclients = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/clients/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setcil(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getplans = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/plans/internet`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setplans(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Fetch Sites and Cores
    const fetchSites = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/sites/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username },
        });

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.site_name,
            value: item.site_id,
          }));
          setSites(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    const fetchCores = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/radius/fiber/cores/select/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          }
        );

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.code,
            value: item.core_id,
          }));
          setCores(options);
        }
      } catch (error) {
        console.error("Error fetching cores:", error);
      }
    };

    fetchSites();
    fetchCores();

    // Fetch wireless access points when site is selected

    getclients();
    getplans();

    return () => {
      isMounted = false;
    };
  }, [authTokens.access, user.username]);

  const fetchWirelessAccessPoints = async (siteName) => {
    try {
      const response = await Axios.get(
        `${API_URL}/radius/wirelessAccessPoint/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username, site: siteName },
        }
      );

      if (response.status === 200) {
        const options = response.data.map((item) => ({
          label: item.name,
          value: item.ap_id,
        }));
        setWirelessAccessPoints(options);

        if (specialSites.includes(siteName)) {
          const defaultOption = options.find((opt) => opt.label === siteName);
          if (defaultOption)
            setSelectedWirelessAccessPoint(defaultOption.value);
        }
      }
    } catch (error) {
      console.error("Error fetching wireless access points:", error);
    }
  };

  const options = notes.map((item) => {
    return {
      label: item.fullname_en,
      value: item.client_id,
    };
  });

  const plano = plans.map((item) => {
    const planNameWithoutSM = item.plan_name.replace("SM-", "");
    return {
      label: planNameWithoutSM,
      value: item.internet_plan_id,
    };
  });

  const opta = [
    { value: "LIMITED", label: "LIMITED" },
    { value: "UNLIMITED", label: "UNLIMITED" },
  ];

  const cona = [
    { value: "Fiber", label: "Fiber" },
    { value: "Wireless", label: "Wireless" },
  ];

  const dua = [
    { value: "First", label: "First" },
    { value: "Half", label: "Half" },
  ];

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      props.closeModal();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  let handleSubmit = async (e) => {
    let lowercasedUsername = username.toLowerCase();
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/subscriptions/`,
      {
        Action: "Post",
        username: lowercasedUsername,
        client_id: client,
        plan_id: plani,
        consumption_option: consumption_option,
        connectivity: connectivity,
        expiry_date: expiration_date,
        site: site,
        suffix: suffix,
        due: due,
        notes: subnotes,
        userdealer: user.username,
        site_id: selectedSite, // Add site if Fiber is selected
        core_id: selectedCore, // Add core if Fiber is selected
        wireless_access_point_id: selectedWirelessAccessPoint, // Add wireless access point if Wireless is selected
        cpe_mac_address: cpeMacAddress, // New Param
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Creation successful!", "success");
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.data.error) {
          showMessage(
            "Creation failed! " + error.response.data.error,
            "danger"
          );
        }
        //showMessage("Creation failed!", "danger");
      });
  }; // New Param

  const isValidMacAddress = (value) => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
    return macRegex.test(value);
  };

  useEffect(() => {
    setCpeError(
      cpeMacAddress && !isValidMacAddress(cpeMacAddress)
        ? "Invalid CPE MAC Address format"
        : ""
    );
  }, [cpeMacAddress]); // CPE MAC Address Validation Use Effect

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Username:
              <input
                className="form-control"
                type="text"
                value={username}
                required
                placeholder="Username"
                onChange={(e) => setusername(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Client Name:
              <Select
                className="search-line"
                placeholder="Choose Client"
                options={options}
                onChange={(opt) => setclient(opt.value)}
              />
            </label>
          </div>

          <div className="form-group">
            <label>
              Plan Name:
              <Select
                className="search-line"
                placeholder="Choose plan"
                options={plano}
                onChange={(opt) => setplano(opt.value)}
              />
            </label>
          </div>

          <label>
            Notes:
            <input
              className="form-control"
              type="text"
              value={subnotes}
              required
              placeholder="Notes"
              onChange={(e) => setnotes(e.target.value)}
            />
          </label>

          <label>
            Connectivity Option:
            <Select
              className="search-line"
              placeholder="Choose Option"
              options={cona}
              onChange={(opt) => setcona(opt.value)}
            />
          </label>

          {connectivity === "Wireless" && (
            <div className="form-group">
              <label>
                Select Site:
                <Select
                  className="search-line"
                  placeholder="Choose Site"
                  options={sites}
                  onChange={(opt) => {
                    // 1) Track both the value and the human‑readable label
                    setSelectedSite(opt.value);
                    setSelectedSiteLabel(opt.label);
                    setsite(opt.label);

                    // 2) Fetch the WAPs for this site
                    fetchWirelessAccessPoints(opt.label);

                    // 3) If this is a “special” site, force CPE MAC = "-"
                    if (specialSites.includes(opt.label)) {
                      setCpeMacAddress("-");
                    } else {
                      setCpeMacAddress("");
                    }
                  }}
                />
              </label>
            </div>
          )}
          {/* New HTML Parts */}
          {connectivity === "Wireless" &&
            selectedSite &&
            !specialSites.includes(selectedSiteLabel) && (
              <div className="form-group">
                <label>
                  Select Wireless Access Point:
                  <Select
                    className="search-line"
                    placeholder="Choose Wireless Access Point"
                    options={wirelessAccessPoints}
                    onChange={(opt) =>
                      setSelectedWirelessAccessPoint(opt.value)
                    }
                  />
                </label>
                <label>
                  CPE MAC Address:
                  <input
                    type="text"
                    className={`form-control ${cpeError ? "is-invalid" : ""}`}
                    style={{ width: "250px" }}
                    value={cpeMacAddress}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const rawNoCols = raw.replace(/:/g, "");
                      const cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");

                      // if characters were dropped, it means a non‑hex was typed
                      setCpeError(cleaned.length !== rawNoCols.length);

                      // format into pairs + colons, uppercase, max 12 hex digits
                      let formatted = "";
                      for (let i = 0; i < cleaned.length && i < 12; i += 2) {
                        if (i > 0) formatted += ":";
                        formatted += cleaned.substring(i, i + 2).toUpperCase();
                      }
                      setCpeMacAddress(formatted);
                    }}
                    maxLength={17} // “AA:BB:CC:DD:EE:FF”
                    placeholder="Enter CPE MAC Address"
                  />
                </label>
                {cpeError && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", fontSize: "0.85rem" }}
                  >
                    Only hexadecimal digits (0–9, A–F) are allowed.
                  </div>
                )}
              </div>
            )}

          {connectivity === "Fiber" && (
            <div className="form-group">
              <label>
                Select Core:
                <Select
                  className="search-line"
                  placeholder="Choose Core"
                  options={cores}
                  onChange={(opt) => setSelectedCore(opt.value)}
                />
              </label>
            </div>
          )}

          <div className="fo">
            <button
              type="submit"
              className="btn btn-primary btn-md"
              disabled={!validate()}
            >
              Create
            </button>
          </div>
        </form>
      </div>

      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default Formi;
